import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { IoLogOut } from "react-icons/io5";

export default function MantraLekhanDashboard() {
  const navigate = useNavigate();
  const [userRank, setUserRank] = useState(1400);
  const [userCount, setUserCount] = useState(1632);
  const [leaderboard, setLeaderboard] = useState([
    { rank: 320, name: "કુમાલીકાં બુજુમાંની વિશેષ", mantra: 2000 },
    { rank: 320, name: "કુમાલીકાં બુજુમાંની વિશેષીં", mantra: 2000 },
    { rank: 330, name: "પુષ્ટી વિશ્વમાંની ચોંર્ધીમ", mantra: 2000 },
    { rank: 331, name: "વીર્ણ વિશ્વમાંની વરોલીધમ", mantra: 2000 },
    { rank: 334, name: "રવિ બલીકમાંની વર્ણમધમ", mantra: 1932, highlight: true },
    { rank: 337, name: "સીતા બુજુમાંની બજુજી", mantra: 1896 },
    { rank: 379, name: "આચલ બલીકમાંન પલમક", mantra: 1863 },
    { rank: 388, name: "ઈશ્વર બુજુમાંની કુશીધમ", mantra: 1900 },
    { rank: 390, name: "પ્રિયમાંનાં વિશ્વમાંની ચર્ધીમ", mantra: 1906 },
  ]);

  const handleLogout = () => {
    // Clear user session/token
    localStorage.removeItem("userToken");
    navigate("/mantra-lekhan-signin");
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#FFF5F3] to-white py-20">
      {/* Stats Bar */}
      <div className="bg-gradient-to-r from-red-50 to-pink-50 border-b-2 border-red-200 py-4 sticky top-0 z-10">
        <div className="max-w-7xl mx-auto px-4 flex items-center justify-between">
          <div className="flex items-center gap-6">
            <div className="text-lg font-semibold text-gray-800">
              Rank:{" "}
              <span className="text-red-600 font-bold">{userRank}/334</span> |
              Count: <span className="text-red-600 font-bold">{userCount}</span>
            </div>
            <div className="text-sm text-gray-600 italic">
              દિવ્ય બ્રીસમાંની ભુજુમાધમ
            </div>
          </div>
          <div className="flex items-center gap-4">
            <div className="w-10 h-10 bg-red-600 rounded-full flex items-center justify-center text-white font-bold">
              🌍
            </div>
            <button
              onClick={handleLogout}
              className="flex items-center gap-2 px-4 py-2 border-2 border-red-600 text-red-600 rounded-full hover:bg-red-50 font-semibold transition"
            >
              <IoLogOut className="w-5 h-5" />
              Logout
            </button>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 py-12">
        {/* Title */}
        <div className="text-center mb-12">
          <h2
            className="text-6xl font-bold"
            style={{ fontFamily: "Philosopher, sans-serif" }}
          >
            <span className="text-red-600">Sw</span>aminarayan
          </h2>
        </div>

        {/* Leaderboard Table */}
        <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gradient-to-r from-red-50 to-pink-50 border-b-2 border-red-200">
                <tr>
                  <th className="px-8 py-4 text-left font-bold text-gray-800 text-lg">
                    Rank
                  </th>
                  <th className="px-8 py-4 text-left font-bold text-gray-800 text-lg">
                    Name
                  </th>
                  <th className="px-8 py-4 text-left font-bold text-gray-800 text-lg">
                    Total Mantra
                  </th>
                </tr>
              </thead>
              <tbody>
                {leaderboard.map((item, index) => (
                  <tr
                    key={index}
                    className={`border-b border-gray-200 transition hover:bg-red-50 ${
                      item.highlight
                        ? "bg-gradient-to-r from-red-100 to-pink-50 border-l-4 border-l-red-600"
                        : ""
                    }`}
                  >
                    <td
                      className={`px-8 py-4 font-semibold text-lg ${
                        item.highlight ? "text-red-600" : "text-gray-800"
                      }`}
                    >
                      {item.rank}
                    </td>
                    <td
                      className={`px-8 py-4 text-lg ${
                        item.highlight
                          ? "text-red-600 font-semibold"
                          : "text-gray-700"
                      }`}
                    >
                      {item.name}
                    </td>
                    <td
                      className={`px-8 py-4 text-lg font-semibold ${
                        item.highlight ? "text-red-600" : "text-gray-800"
                      }`}
                    >
                      {item.mantra.toLocaleString()}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Pagination or Load More */}
        <div className="flex justify-center mt-8">
          <button className="px-8 py-3 bg-red-600 hover:bg-red-700 text-white font-semibold rounded-full transition">
            Load More
          </button>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-gray-100 py-8 mt-12 border-t-2 border-red-200">
        <div className="max-w-7xl mx-auto px-4 text-center text-gray-600">
          <p>© 2024 Shree Swaminarayan Mandir. All rights reserved.</p>
          <p className="text-sm mt-2">
            Mantra Lekhan - An Endeavor to Please Bhagwan Swaminarayan
          </p>
        </div>
      </footer>
    </div>
  );
}
